import { Transaction } from './../../../data/Transaction';
import { CustomerAccount } from './../../../data/CustomerAccount';
import { Router } from '@angular/router';
import { Identity } from './../../../Identity';
import { Component, OnInit } from '@angular/core';
import { VisitorCardStub } from 'src/app/data/VisitorCardStub';
import { VisitorCardService } from 'src/app/services/visitor-card.service';
import { VisitorCard } from 'src/app/data/VisitorCard';
import { EntitlementService } from 'src/app/services/entitlement.service';

@Component({
  selector: 'app-visitor-card-accounts',
  templateUrl: './visitor-card-accounts.component.html',
  styleUrls: ['./visitor-card-accounts.component.css']
})
export class VisitorCardAccountsComponent implements OnInit {
  identity: Identity;
  visitorCard: VisitorCard;
  visitorCardStub: VisitorCardStub;
  recentVisitorCards: VisitorCardStub[];
  customerAccount: CustomerAccount;
  transactions: Transaction[];

  constructor(
    private visitorCardService: VisitorCardService,
    private entitlementService: EntitlementService,
    private router: Router
  ) {}

  ngOnInit() {
    const card = this.visitorCardService.getSelectedVisitorCardStub();

    this.refreshCardData(card);

    this.recentVisitorCards = this.visitorCardService.getRecentVisitorCardStubs();

    const that = this;
    this.visitorCardService.visitorCardStubSelected.subscribe(data => {
      that.refreshCardData(data);
    });
  }

  refreshCardData(card: VisitorCardStub) {
    if (card) {
      this.visitorCardStub = card;
      this.visitorCardService
        .getVisitorCardDetails(card.cardSeq)
        .subscribe(data => {
          this.identity = data.identity;
          this.visitorCard = data.card;
          this.customerAccount = data.customerAccount;
        });
    } else {
      this.router.navigate(['/visitorCards']);
    }
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
